import { render, staticRenderFns } from "./TrainingProtocolHub.vue?vue&type=template&id=2848b83a&scoped=true"
import script from "./TrainingProtocolHub.vue?vue&type=script&lang=js"
export * from "./TrainingProtocolHub.vue?vue&type=script&lang=js"
import style0 from "./TrainingProtocolHub.vue?vue&type=style&index=0&id=2848b83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2848b83a",
  null
  
)

export default component.exports